import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";

export default function Account() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user === false) nav("/connexion");
    if (user) api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {});
  }, [user, nav]);

  if (!user) return <div className="pt-40 pb-32 text-center min-h-[60vh]" style={{ color: "var(--lo-muted)" }}>Chargement...</div>;

  return (
    <div className="pt-32 pb-32 min-h-[70vh] max-w-4xl mx-auto px-6">
      <div className="flex items-center justify-between mb-12">
        <div>
          <p className="overline mb-2">Mon compte</p>
          <h1 className="font-display text-4xl" style={{ fontWeight: 300 }}>Bonjour, {user.name}</h1>
        </div>
        <button onClick={() => { logout(); nav("/"); }} className="btn-ghost h-11 px-6" data-testid="logout-btn">Déconnexion</button>
      </div>

      {user.role === "admin" && (
        <button onClick={() => nav("/admin")} className="btn-primary h-12 px-8 mb-10" data-testid="goto-admin">Accéder au back-office</button>
      )}

      <p className="overline mb-4">Mes commandes</p>
      {orders.length === 0 ? (
        <p className="text-sm" style={{ color: "var(--lo-muted)" }}>Aucune commande pour le moment.</p>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="card-lux p-5 flex justify-between items-center" data-testid="my-order">
              <div><p className="font-display text-lg">{o.items_label}</p>
                <p className="text-xs" style={{ color: "var(--lo-muted)" }}>{new Date(o.created_at).toLocaleDateString("fr-FR")}{o.tracking_url ? " · Expédiée" : ""}</p></div>
              <div className="text-right">
                <span className="overline block" style={{ color: o.payment_status === "paid" ? "var(--lo-rose-hi)" : "var(--lo-muted)" }}>
                  {o.payment_status === "paid" ? "Payée" : "En attente"}
                </span>
                {o.tracking_url && <a href={o.tracking_url} target="_blank" rel="noreferrer" className="overline link-underline" style={{ fontSize: "0.55rem", color: "var(--lo-rose-hi)" }} data-testid="track-link">Suivre le colis</a>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
